module.exports = __webpack_public_path__ + "img/deemoney.b81f8e52.png";